<template>
  <el-dialog :close-on-click-modal="false"  
    title="订单导入预览"
    :visible.sync="visible"
    width="1000px"
    top="5vh"
    class="dialog"
    :before-close="handleClose"
    
  >
    <el-table
      id="myOrder"
      ref="table"
      :data="orderData"
      class="table"
      :default-expand-all="true"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table
            ref="detailTable"
            class="table"
            border
            :data="[props.row]"
            :show-header="false"
          >
            <el-table-column width="300">
              <template slot-scope="scope">
                <div class="table-info-wrap">
                  <div
                    class="table-info"
                    v-for="(item, index) in scope.row.skuList"
                    :key="index"
                  >
                    <div class="left">
                      <img
                        class="mini-img"
                        :src="item.picUrl"
                        slot="reference"
                      />
                    </div>
                    <div class="right">
                      <div>
                        <b>{{ item.proName || "-" }}</b>
                      </div>
                      <div>
                        Item ID：{{ item.appNo || "-" }}
                      </div>
                      <div>
                        成品编号：：{{ item.appId || "-" }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <div class="loan-wrap">
                  {{ dictMap["currency_mark"][scope.row.currency] }}
                  {{ scope.row.saleActPay || "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" width="150">
              <template slot-scope="scope">
                <div class="loan-wrap">
                  <div>
                    Brandy【USA】
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center">
              <template slot-scope="scope">
                <div class="loan-wrap">
                  <div>
                    地址：{{ "-" }}
                  </div>
                  <div>
                    电话：{{ "-" }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="产品信息" align="left" width="300">
        <template slot-scope="scope">
          订单号：{{ scope.row.appNo }}
        </template>
      </el-table-column>
      <el-table-column
        label="订单金额"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        label="收件人【国家】"
        align="center"
        width="150"
      ></el-table-column>
      <el-table-column
        label="收货信息"
        align="center"
      >
        <template slot-scope="scope">
          下单时间：{{ scope.row.orderTime }}
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="primary" @click="sure" size="small">
        确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listCurrencyFee, addCurrencyFee } from "@/api/order/all";
import { mapGetters } from "vuex";

export default {
  name: "dialog",
  data() {
    return {
      exchangeData: [],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    orderData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  watch: {
    visible() {
      this.getData();
    },
  },
  methods: {
    getData() {
      listCurrencyFee().then((res) => {
        this.exchangeData = res.data;
      });
    },
    sure() {
      addCurrencyFee(this.exchangeData).then((res) => {
        if (res.code !== 200) {
          this.$message.error("修改失败");
        } else {
          this.$message.success("修改成功");
          this.$emit("onOk");
        }
      });
    },
    handleClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {

}
.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table {
  margin: 0 auto;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #EBEEF5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 10px;
  padding: 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 20px;
  width: 97px;
  height: 97px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
}

.table-info .left .mini-img {
  width: 95px;
  height: 95px;
}

.table-info .right {
  font-size: 12px;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: left;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.dialog {
  font-size: 12px;
}

.table /deep/.el-table__expand-column {
  width: 0px !important;
  height: 0px !important;
  visibility: hidden !important;
  cursor: not-allowed !important;
}

.table /deep/.el-table__expanded-cell[class*=cell] {
  padding: 8px 16px;
}
</style>
